import EmblaCarousel from 'embla-carousel'
const form = document.querySelector('.lookup form')
const wrap = document.querySelector('.lookup .wrap')
const recaptchaKey = '6Lc0nYQtAAAAAKyHwu4aEfM6sJF21ADY_AHpzIAG';

const submitEndpoint = 'https://us-central1-ky-candidate-lookup26.cloudfunctions.net/lookup'

export const updateSelectedSnapDisplay = (emblaApi, snapDisplay) => {
  const updateSnapDisplay = (emblaApi) => {
    const selectedSnap = emblaApi.selectedScrollSnap()
    const snapCount = emblaApi.scrollSnapList().length
    snapDisplay.innerHTML = `${selectedSnap + 1} / ${snapCount}`
  }

  emblaApi.on('select', updateSnapDisplay).on('reInit', updateSnapDisplay)

  updateSnapDisplay(emblaApi)
}

form.addEventListener('submit', async e => {
    e.preventDefault()
    wrap.setAttribute('aria-busy', 'true')
    form.querySelector('button').setAttribute('disabled', 'disabled')
    wrap.style.minHeight = `${wrap.offsetHeight}px`

    const checkURL = new URL('check.svg', import.meta.url)
    const warnURL = new URL('warning.svg', import.meta.url)

    await grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(recaptchaKey, { action: 'submit' })
        const data = new FormData(form)
        data.set('_token', token)

        const resp = await fetch(submitEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        })
        const body = await resp.json()

        console.log(body)

        if (!body || !body.candidates || body.candidates.length === 0) {
            wrap.innerHTML = `
                <p class="no-results">For more information about how to vote this cycle, please visit <a href="https://iwillvote.com/ky">IWillVote.com</a></p>`
        } else {
            document.querySelector('#findYourDistrict').remove()
            wrap.innerHTML = ''

            if (body.partial) {
                wrap.innerHTML = '<p class="message">We couldn\'t find an exact match for your address, but these districts and locations are near you.</p>'
            }

            const msg = document.createElement('div')
            msg.classList.add('message')
            msg.innerHTML = 'Due to data limitations, the results below may include more or fewer nonpartisan races than will appear on your actual ballot.  For a full sample ballot, please reach out to your local county clerk.'

            wrap.appendChild(msg)
            
            if (!body.iwv.error_code)
            {

            const pollingLocation = document.createElement('div')
            pollingLocation.classList.add('embla','section')
            const pollingLocationTitle = document.createElement('h2')
            pollingLocationTitle.innerText = 'Where to Vote'
            pollingLocation.appendChild(pollingLocationTitle)
            const embla = document.createElement('div')
            pollingLocation.appendChild(embla)
            embla.classList.add('embla__viewport')
            const list = document.createElement('ul')
            embla.appendChild(list)
            list.classList.add('embla__container')

            const controls = document.createElement('div')
            pollingLocation.appendChild(controls)
            controls.classList.add('embla__controls')

            const prev = document.createElement('button')
            prev.classList.add('embla__prev')
            prev.innerHTML = '&larr;'

            const next = document.createElement('button')
            next.classList.add('embla__next')
            next.innerHTML = '&rarr;'

            const snapDisplay = document.createElement('div')
            snapDisplay.classList.add('embla__selected-snap-display')
            snapDisplay.innerHTML = '1 / 0'

            controls.append(prev)
            controls.append(next)
            controls.appendChild(snapDisplay)

            for(const loc of body.iwv.polling_locations){
                const li = document.createElement('li')
                list.appendChild(li)
                li.classList.add('embla__slide')

                const location = document.createElement('div')
                li.appendChild(location)
                location.classList.add('location')

                location.innerHTML = `
                    <h3>${loc.location_name}</h3>
                    <p>${loc.address_line_1}</p>
                    ${loc.address_line_2 != null ? `<p>${loc.address_line_2}</p>` : ''}
                    <p>${loc.city}, ${loc.state_code} ${loc.zip}</p>
                    <p>${loc.dates_hours}</p>
                    `
                const map = document.createElement('div')
                li.appendChild(map)
                map.classList.add('map')

                map.innerHTML = `<gmpx-api-loader key="AIzaSyBP83wrdeU5yEAAzQNavRCqCX8jtQErj9k"></gmpx-api-loader>`

            wrap.appendChild(pollingLocation)

            }

            const emblaApi = EmblaCarousel(embla, { loop: false })
            prev.addEventListener('click', () => emblaApi.scrollPrev(), false)
            next.addEventListener('click', () => emblaApi.scrollNext(), false)

            const toggleButtonsDisabled = (emblaApi) => {
                const setButtonState = (button, enabled) => {
                    button.toggleAttribute('disabled', !enabled)
                }
                setButtonState(prev, emblaApi.canScrollPrev())
                setButtonState(next, emblaApi.canScrollNext())
            }

            toggleButtonsDisabled(emblaApi)
            emblaApi.on('select', toggleButtonsDisabled)
            emblaApi.on('reinit', toggleButtonsDisabled)
            updateSelectedSnapDisplay(emblaApi, snapDisplay)
        }

            const candidates = document.createElement('div')
            candidates.classList.add('section')
            wrap.appendChild(candidates)

            const candidatesTitle = document.createElement('h2')
            candidatesTitle.innerText = 'Who to Vote For'
            candidates.appendChild(candidatesTitle)

            const legend = document.createElement('ul')
            legend.classList.add('candidates')
            const legendSupport = document.createElement('li')
            legend.appendChild(legendSupport)
            legendSupport.classList.add('support')
            legendSupport.innerHTML = `<img src="${checkURL.toString()}" alt="Check mark" title="These Democrats are counting on your vote!" /><p>These Democrats are counting on your vote!</p>`

            // const legendOppose = document.createElement('li')
            // legend.appendChild(legendOppose)
            // legendOppose.classList.add('oppose')

            // legendOppose.innerHTML = `<img src="${warnURL.toString()}" alt="Warning" title="This candidate is pursuing an extremist political agenda." /><p>This candidate is pursuing an extremist political agenda.</p>`

            candidates.appendChild(legend)

            const cands = body.candidates.sort((a, b) => {return (a.office_order - b.office_order) || (a.position.localeCompare(b.position))})

            console.log(cands)

            for (const race of cands) {
                const h3 = document.createElement('h3')
                h3.innerText = race.candidates[0].position
                const ul = document.createElement('ul')
                ul.classList.add('candidates')

                for (const candidate of race.candidates.sort((a, b) => a.candidate_order - b.candidate_order)) {
                    const li = document.createElement('li')
                    ul.appendChild(li)
                    li.classList.add(candidate.status)
                    li.innerHTML = `
                        ${candidate.status === 'support'
                            ? `<img src="${checkURL.toString()}" alt="Check mark" title="This Democrat is counting on your vote." />`
                            : candidate.status === 'oppose'
                                ? `<img src="${warnURL.toString()}" alt="Warning" title="This candidate is pursuing an extremist political agenda." />`: '<span class="spacer" aria-hidden="true"></span>'}
                        <p>${candidate.name}</p>`
                }

                candidates.appendChild(h3)
                candidates.appendChild(ul)
            }
        }

        wrap.setAttribute('aria-busy', 'true')

        wrap.scrollIntoView({ 
                behavior: "smooth", 
                block: "start", 
                inline: "nearest" 
                });
                
    })
    return false
})
